import { gql } from '@apollo/client';

export const FIND_SOCIAL_PROFILE_INFORMATION = gql`
  query SocialProfileInformation($id: ID!) {
    socialProfileInformation(id: $id) {
        id,
        emailAddress
      }
    }
`;
